import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";

function OverlapMobile({ app, config }) {
  const { container } = config.overlap;
  const { title } = container[0].cards[0];

  return (
    <div className="app overlap">
      <div className="appContent">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[0].cards[0].nativeObject.id}
            header={{
              hardTitle: title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[0].cards[0].nativeObject.id}
              reference={{
                id: container[0].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[1].cards[0].nativeObject.id}
            header={{
              hardTitle: title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[1].cards[0].nativeObject.id}
              reference={{
                id: container[1].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

OverlapMobile.defaultProps = {
  app: null,
  config: {},
};

OverlapMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverlapMobile;
